import PropTypes from 'prop-types'
import ImmutableProptypes from 'react-immutable-proptypes'
import React, { PureComponent } from 'react'
import classnames from 'classnames'
import { OrderedMap, List } from 'immutable'
import { connect } from 'react-redux'
import Moment from 'moment'
import ReactTable from 'react-table'

import { TASK_TYPES } from '_utils/logEntryType'

import Icon from '_components/icon'
import CategoryTabBodyTimeframe from '_components/categoryTabs/categoryTabBodyTimeframe'
import { updateLastActivityAt } from '_modules/user/actions'
import { createTodayItem } from '_modules/today-items/actions'
import { createTomorrowItem } from '_modules/tomorrow-items/actions'
import { momentHumanize } from '_utils/helperFunction'
import TChart from '_components/tChart'

import styles from './styles.css'

const ICONS = [
  {
    class: 'fa-frown-o',
    color: 'rgba(255, 71, 68, 1)',
  },
  {
    class: 'fa-meh-o',
    color: 'rgba(237, 224, 109, 1)',
  },
  {
    class: 'fa-smile-o',
    color: 'rgba(171, 225, 136, 1)',
  },
]

const TIMEFRAMES = {
  Today: {
    date: Moment().format('YYYY-MM-DD'),
  },
  'This Week': {
    date: Moment()
      .subtract(7, 'days')
      .format('YYYY-MM-DD'),
  },
  'This Month': {
    date: Moment()
      .subtract(1, 'months')
      .format('YYYY-MM-DD'),
  },
  All: {
    date: Moment(0).format('YYYY-MM-DD'),
  },
}

const mapStateToProps = ({ nonTask }) => ({
  nonTask,
})

const mapDispatchToProps = {}

class NonTaskReflection extends PureComponent {
  static propTypes = {
    nonTask: ImmutableProptypes.map,
    type: PropTypes.number.isRequired,
  }

  static defaultProps = {
    nonTask: new Map(),
  }

  state = {
    selectedTimeframe: 'Today',
  }

  getListData = () => {
    const { nonTask, type } = this.props
    const { selectedTimeframe } = this.state
    const timeframe = TIMEFRAMES[selectedTimeframe].date

    const tableData = nonTask
      .toArray()
      .filter(x => Moment(x.createdAt).isSameOrAfter(timeframe, 'day') && x.type === type)
      .sort((a, b) => {
        if (a.createdAt > b.createdAt) return -1
        return 1
      })

    return tableData
  }

  handleTimeframeClick = click => {
    this.setState({
      selectedTimeframe: click.currentTarget.id,
    })
  }

  renderNonTask = nonTask => {
    const rankIconIndex = Math.min(Math.floor(nonTask.rank / 3), 2)
    const rankIconClass = ICONS[rankIconIndex].class
    const rankIconColor = ICONS[rankIconIndex].color

    return (
      <div key={nonTask._id} className={classnames(styles.tableRow)}>
        <div style={{ display: 'flex', flex: 1.5, alignItems: 'center', paddingRight: 7 }}>
          <div>
            <i className={`fa ${rankIconClass}`} style={{ fontSize: 30, color: rankIconColor }} />
          </div>
          <div style={{ marginLeft: 10 }}>
            <p className={classnames(styles.rowText)}>{nonTask.label}</p>
            <p
              className={classnames(styles.rowText)}
              style={{ color: 'rgba(255,255,255,0.4)' }}
            >{`rank: ${nonTask.rank}`}</p>
          </div>
        </div>
        <div style={{ flex: 1, flexDirection: 'column' }}>
          <p className={classnames(styles.rowText)}>
            {Moment(nonTask.createdAt).format('MM/DD/YYYY')}
          </p>
          <p className={classnames(styles.rowText)} style={{ color: 'rgba(255,255,255,0.4)' }}>
            {Moment(nonTask.createdAt).format('h:mm a')}
          </p>
          <p className={classnames(styles.rowText)} style={{ color: 'rgba(255,255,255,0.4)' }}>
            {Moment(nonTask.createdAt).format('dddd')}
          </p>
        </div>
        <div className={classnames(styles.reflection)} style={{ flex: 3 }}>
          <p className={classnames(styles.rowText)}>{nonTask.reflection}</p>
        </div>
      </div>
    )
  }

  render() {
    const { selectedTimeframe } = this.state
    const { type } = this.props
    const data = this.getListData()

    const keys = Object.keys(TIMEFRAMES)

    return (
      <CategoryTabBodyTimeframe
        selectedTimeframe={selectedTimeframe}
        timeframes={TIMEFRAMES}
        onChangeTimeframe={this.handleTimeframeClick}
      >
        {data.length > 0 ? (
          <div className={classnames(styles.tableContainer)}>
            <div className={classnames(styles.tableColumnHeadersContainer)}>
              <span className={classnames(styles.tableColumnHeaders)} style={{ flex: 1.5 }}>
                Label & Rank
              </span>
              <span className={classnames(styles.tableColumnHeaders)} style={{ flex: 1 }}>
                Date/Time
              </span>
              <span className={classnames(styles.tableColumnHeaders)} style={{ flex: 3 }}>
                Reflection
              </span>
            </div>
            <div className={classnames(styles.tableRowsContainer)}>
              {data.map(this.renderNonTask)}
            </div>
          </div>
        ) : (
          <div style={{ alignItems: 'center', flex: 1 }}>
            <span className={classnames(styles.rowText)} style={{ textAlign: 'center' }}>
              No Items to Show
            </span>
          </div>
        )}
      </CategoryTabBodyTimeframe>
    )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NonTaskReflection)



// WEBPACK FOOTER //
// ./src/views/log/nonTaskReflection/index.js